import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  grid-template-columns: max-content;
  gap: 15px;
`;
